"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isColorValid = exports.normalizeColor = exports.isPercentageValid = exports.normalizePercentage = exports.toHEX = exports.toRGB = void 0;
var tslib_1 = require("tslib");
var isNumber_1 = tslib_1.__importDefault(require("lodash/isNumber"));
var isString_1 = tslib_1.__importDefault(require("lodash/isString"));
var startsWith_1 = tslib_1.__importDefault(require("lodash/startsWith"));
var toLower_1 = tslib_1.__importDefault(require("lodash/toLower"));
var colorRegex = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i;
exports.toRGB = function (hex) { return [
    parseInt(hex[0] + hex[1], 16),
    parseInt(hex[2] + hex[3], 16),
    parseInt(hex[4] + hex[5], 16)
]; };
exports.toHEX = function (rgb) {
    var hex = Math.round(rgb).toString(16);
    return hex.length === 1 ? "0" + hex : hex;
};
exports.normalizePercentage = function (percentage) {
    return isNumber_1.default(percentage)
        ? percentage
        : parseFloat(percentage.replace(/,/g, '.'));
};
exports.isPercentageValid = function (percentage) { return !!percentage && (isString_1.default(percentage) || isNumber_1.default(percentage)); };
/**
 * Normalizes hex color notation
 * @param color hex color - three or 6 characters optionally prepended by #
 * @returns string
 */
function normalizeColor(color) {
    var hexValue = startsWith_1.default(color, '#') ? color.replace('#', '') : color;
    return hexValue.length === 3
        ? "" + hexValue[0] + hexValue[0] + hexValue[1] + hexValue[1] + hexValue[2] + hexValue[2]
        : hexValue;
}
exports.normalizeColor = normalizeColor;
/**
 * Validates string against color hex format
 * @param color string
 * @returns boolean
 */
function isColorValid(color) {
    if (!color || !isString_1.default(color) || !colorRegex.test(color)) {
        return false;
    }
    var hexColor = normalizeColor(color);
    var hexNumber = hexColor.toString(16);
    var isValid = hexNumber === toLower_1.default(hexColor);
    return isValid;
}
exports.isColorValid = isColorValid;
